import clsx from 'clsx';

import { StatusType } from '@/react/edge/edge-stacks/types';

import { TooltipWithChildren } from '@@/Tip/TooltipWithChildren';

import { StatusType as ScheduleStatusType } from '../../types';

import styles from './DeploymentCounter.module.css';

export function DeploymentCounter({
  count,
  total,
  type,
  scheduleStatus,
}: {
  count: number;
  total: number;
  type: StatusType;
  scheduleStatus: ScheduleStatusType;
}) {
  const done = count === total;
  const withPulse = scheduleStatus === ScheduleStatusType.InProgress && !done;
  return (
    <TooltipWithChildren message={`${count} of ${total}`}>
      <div
        className="relative h-3 w-full overflow-hidden rounded-full bg-gray-3"
        style={{
          boxShadow: 'inset 0px 1.04px 1.04px 0px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          style={{
            width: `${(count / total) * 100}%`,
          }}
          className={clsx(
            'h-full rounded-full transition-all duration-300 ease-in-out',
            {
              'bg-success-7': type === StatusType.RemoteUpdateSuccess,
              'bg-error-7': type === StatusType.Error,
              'bg-blue-7': type === StatusType.Acknowledged,
              'bg-yellow-6': type === StatusType.Deploying,
            },
            withPulse ? styles.withPulse : ''
          )}
        />
      </div>
    </TooltipWithChildren>
  );
}
